module.exports = __webpack_public_path__ + "assets/img/home3-box3-img1.6e932851.png";